import { render } from "./NachaTransactionsList.vue?vue&type=template&id=6d254ea7"
import script from "./NachaTransactionsList.vue?vue&type=script&lang=js"
export * from "./NachaTransactionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__